import { Fragment } from "react";
import CommonHeader from "../../components/common/commonHeader/CommonHeader";
import { Box, Container, Grid, Typography } from "@mui/material";
import ChangePasswordForm from "../../components/EditProfileComponent/ChangePasswordForm";

export const EditProfile = () => {
  return (
    <Fragment>
      <CommonHeader />
      <Box sx={{ width: "100%", height: "80px" }}></Box>
      <Container maxWidth="lg">
        <Typography
          variant="h4"
          gutterBottom
          component="div"
          sx={{
            fontWeight: 700,
          }}
        >
          Edit Profile
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6} lg={6}>
            <Typography
              variant="h6"
              gutterBottom
              component="div"
              sx={{ textDecoration: "underline" }}
            >
              Change Password
            </Typography>

            <Box>
              <ChangePasswordForm/>
            </Box>
          </Grid>
          <Grid item xs={12} md={6} lg={6}></Grid>
        </Grid>
      </Container>
    </Fragment>
  );
};
